import React, { useState, useEffect } from 'react';
import { db, auth } from '../firebaseconfig';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { updateEmail, updatePassword } from 'firebase/auth';
import PageShell from './PageShell';

const UserSettingsPage = ({ user }) => {
  const [newEmail, setNewEmail] = useState(user?.email || '');
  const [newPassword, setNewPassword] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  useEffect(() => {
    if (!db || !user?.uid) return;
    const fetchUserData = async () => {
      try {
        await getDoc(doc(db, 'users', user.uid));
      } catch (err) {
        console.error('Error fetching user data', err);
      }
    };
    fetchUserData();
  }, [user]);

  const handleUpdateEmail = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMessage('');
    if (!auth?.currentUser || !db) {
      setError('Account services are not available.');
      return;
    }
    try {
      if (newEmail !== user.email) {
        await updateEmail(auth.currentUser, newEmail);
        await updateDoc(doc(db, 'users', user.uid), { email: newEmail });
        setSuccessMessage('Email updated successfully.');
      }
    } catch (err) {
      setError('Failed to update email: ' + err.message);
    }
  };

  const handleUpdatePassword = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMessage('');
    if (!auth?.currentUser) {
      setError('Account services are not available.');
      return;
    }
    try {
      if (newPassword) {
        await updatePassword(auth.currentUser, newPassword);
        setSuccessMessage('Password updated successfully.');
        setNewPassword('');
      }
    } catch (err) {
      setError('Failed to update password: ' + err.message);
    }
  };

  return (
    <PageShell title="User settings" subtitle="Manage your RobinhoodSpace account.">
      {error && <p className="rhs-error" role="alert">{error}</p>}
      {successMessage && <p className="rhs-ok-text">{successMessage}</p>}

      <form onSubmit={handleUpdateEmail} className="rhs-form-block">
        <label htmlFor="email">Email</label>
        <input
          type="email"
          id="email"
          name="email"
          autoComplete="email"
          value={newEmail}
          onChange={(e) => setNewEmail(e.target.value)}
          required
        />
        <button type="submit" className="rhs-btn">
          Update email
        </button>
      </form>

      <form onSubmit={handleUpdatePassword} className="rhs-form-block">
        <label htmlFor="password">New password</label>
        <input
          type="password"
          id="password"
          name="new-password"
          autoComplete="new-password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          minLength={6}
        />
        <button type="submit" className="rhs-btn">
          Update password
        </button>
      </form>
    </PageShell>
  );
};

export default UserSettingsPage;
